import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the filter reports view.
 * @extends JetView
 */
export default class FilterReportsView extends JetView {
    /**
     * Configures the layout of the filter reports view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form
        const left = {
            margin: 5,
            rows: [
                {
                    hidden: devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    height: 1,
                },
                {
                    view: 'text', // Input field for User ID
                    name: 'Id',
                    type: 'number',
                    label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Localized label
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    labelPosition: 'top',
                    placeholder: _('ID Usuario'), // Localized placeholder
                },
            ],
        };

        // Center left section of the form
        const center_left = {
            margin: 5,
            rows: [
                {
                    hidden: devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    height: 1,
                },
                {
                    view: 'text', // Input field for User Login
                    name: 'Login',
                    label: "<span class='icon-mail'></span>" + _('Usuario (Correo electrónico)'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Usuario (Correo electrónico)'), // Localized placeholder
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                },
            ],
        };

        // Center right section of the form
        const center_right = {
            margin: 5,
            rows: [
                {
                    hidden: devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    height: 1,
                },
                {
                    view: 'text', // Input field for User Name
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Nombre'), // Localized placeholder
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                },
            ],
        };

        // Right section of the form
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for User Status
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [
                        // Options for the dropdown
                        { id: 'A', value: _('Activo') }, // Active
                        { id: 'I', value: _('Inactivo') }, // Inactive
                        { id: 'R', value: _('Rechazado') }, // Rejected
                    ],
                },
            ],
        };

        // Upper section combining all parts
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 },
                center_left,
                { gravity: 0, minWidth: 10 },
                center_right,
                { gravity: 0, minWidth: 10 },
                right,
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Localized label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Localized label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('marketing:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
